import React, { useContext } from 'react';
import { ICustomGroups, TKeyForNewItemToCarousel } from 'types';
import {
	IStyleSettingsCarouselUploaderContext,
	StyleSettingsCarouselUploaderContext,
} from '../styleSettingsCarouselUploaderState/styleSettingsCarouselUploaderContext';
import PDFSection from 'components/UploaderAndDownloader/PDFSection';

interface IProps {
	onUploadPDF: (fileId: string, keyForGroup: TKeyForNewItemToCarousel) => void;
	onDeleteFile: (keyForGroup: TKeyForNewItemToCarousel) => void;
	keyForGroup: TKeyForNewItemToCarousel;
	IdForPDFUploader: string;
	group: ICustomGroups;
	isShowPDFUploader: boolean;
	maxFileSizeMB: number;
}

const PDFBlock: React.FC<IProps> = ({
	onUploadPDF,
	onDeleteFile,
	keyForGroup,
	IdForPDFUploader,
	group,
	isShowPDFUploader,
	maxFileSizeMB,
}) => {
	const { changeTypeOfErrorModalWindow } = useContext<IStyleSettingsCarouselUploaderContext>(
		StyleSettingsCarouselUploaderContext,
	);

	const filePath = group.items.find((el) => el.mediaFileType === 3 && el.filePath)?.filePath || null;

	return (
		<PDFSection
			onUploadPDF={(fileId) => onUploadPDF(fileId, keyForGroup)}
			onDeleteFile={() => onDeleteFile(keyForGroup)}
			onSizeError={() => changeTypeOfErrorModalWindow('pdfFileSizeExceeded')}
			IdForPDFUploader={IdForPDFUploader}
			filePath={filePath}
			isShowPDFUploader={isShowPDFUploader}
			maxFileSizeMB={maxFileSizeMB}
		/>
	);
};

export default PDFBlock;
